import type { PostFormat } from "@nlc/shared-types";

export type Platform = "facebook" | "instagram";

export interface PostType {
  description: string;
  format: PostFormat;
  id: `${Platform}-${PostFormat}`;
  label: string;
  platform: Platform;
}

export const PLATFORM_LABELS: Record<Platform, string> = {
  facebook: "Facebook",
  instagram: "Instagram",
};

export const POST_TYPES: PostType[] = [
  {
    description: "Image or carousel in the feed",
    format: "post",
    id: "instagram-post",
    label: "Post",
    platform: "instagram",
  },
  {
    description: "Full-screen vertical video",
    format: "reel",
    id: "instagram-reel",
    label: "Reel",
    platform: "instagram",
  },
  {
    description: "Full-screen, disappears after 24 hours",
    format: "story",
    id: "instagram-story",
    label: "Story",
    platform: "instagram",
  },
  {
    description: "Update on the Page feed",
    format: "post",
    id: "facebook-post",
    label: "Post",
    platform: "facebook",
  },
  {
    description: "Full-screen vertical video",
    format: "reel",
    id: "facebook-reel",
    label: "Reel",
    platform: "facebook",
  },
  {
    description: "Full-screen, disappears after 24 hours",
    format: "story",
    id: "facebook-story",
    label: "Story",
    platform: "facebook",
  },
];
